<template>
  <div class="siteblocks">
    <hero-panel />
    <!--domain-promo/-->
    <promo-advertisement
        v-if="enablePromo"
        v-show="!$isMobile()"
        :banner="promoImage"
        background-color="rgb(184, 220, 254)"
        background-gradient="linear-gradient(90deg, rgb(184, 220, 254) 60%, rgb(184, 220, 254) 100%)"
    />
    <!-- Show ALL panels "except" the HERO panel. -->
    <marketing-block v-for="panel in otherPanels"
                     :key="panel.name"
                     v-bind="panel"
                     view="sitebuilder" />

    <div class="service-garden-wrapper">
      <h2>{{$t(`sitebuilder.SERVICE_GARDEN_HEADING`)}}</h2>
      <div class="service-garden">
        <service-garden-item v-for="item in serviceGarden"
                             v-bind="item"
                             :key="`sitebuilder.${item.name}`"
                             view="sitebuilder" />
      </div>
    </div>

    <div class="sitebuilder-final-cta">
      <h2>{{$t(`sitebuilder.FINAL_CTA_HEADING`)}}</h2>
      <p>{{$t(`sitebuilder.FINAL_CTA_BODY`)}}</p>
      <md-button class="md-raised md-primary" to="/sitebuilder/templates">{{$t(`sitebuilder.FINAL_CTA_ACTION`)}}</md-button>
      <div class="note">Note: As part of our efforts to maintain a high-quality platform, free accounts can build and edit SiteBlocks websites but must upgrade to a paid plan to publish them live.</div>
    </div>
  </div>
</template>

<script>
import HeroPanel from 'components/sitebuilder/hero-panel'
import MarketingBlock from 'components/marketing-block'
import PromoAdvertisement from 'components/promo-advertisement'
import DomainPromo from 'components/domain-promo'
import style from 'styles/siteblocks.scss'
import { PANELS, SERVICE_GARDENS } from 'app-constants'
import ServiceGardenItem from 'components/service-garden-item'
import axios from 'axios'

export default {
  name: 'sitebuilder',
  components: {
    'hero-panel': HeroPanel,
    'marketing-block': MarketingBlock,
    'promo-advertisement': PromoAdvertisement,
    'domain-promo': DomainPromo,
    'service-garden-item': ServiceGardenItem
  },
  data () {
    let promoImage = require(`assets/img/home/frontjuly.png`)
    const welcomePanel = PANELS.SITEBUILDER.filter(panel => panel.name === 'WELCOME');
    const otherPanels = PANELS.SITEBUILDER.filter(panel => panel.name !== 'WELCOME');
    return {
      enablePromo: false,
      panels: PANELS.SITEBUILDER,
      serviceGarden: SERVICE_GARDENS.SITEBUILDER,
      loading: true,
      onsale: [],
      promoImage,
      welcomePanel,
      otherPanels
    }
  },
  methods: {
    onSubmit: function () {
      window.location.href = '/domains/search/results/' + $('.domain-search').val()
    }
  },
  async mounted() {
    // if(window.sessionStorage.getItem('bn_domains_sales')!==null) {
    //   this.onsale = JSON.parse(window.sessionStorage.getItem('bn_domains_sales'))
    //   this.loading = false
    // } else {
    //   let res = await axios.get('https://api-v2.bravenet.com/domains/onsale')
    //   window.sessionStorage.setItem('bn_domains_sales',JSON.stringify(res.data))
    //   this.onsale = res.data
    //   this.loading = false
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.md-progress-spinner {
  .md-progress-spinner-circle {
    stroke: #fff!important;
    color: #fff!important;
  }
}
</style>
